// DATE - TIME DATA FOR ORDER MEET UP
export const dateTimeGlobals = {
  addedTime: 60, //number of minutes we add to default time (value will be at least + 60 mins)
  start: 9, //working day starts from 9:00 o'clock
  end: 19, //working day ends at 19:00 o'clock
  weekends: [0, 6], //array with two values. Values can be from 0 to 6
  activeDays: 1209600000, //period of time, when customer can make orders, milliseconds (here 2 weeks)
};
